import { useState, useEffect } from "react";
import { Bell, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { usePushNotifications } from "@/hooks/usePushNotifications";

const PushNotificationPrompt = () => {
  const { user } = useAuth();
  const { subscribe, dismissPrompt, shouldShowPrompt } = usePushNotifications();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user) {
      setVisible(false);
      return;
    }
    // Pequeño delay tras el login para no interrumpir la primera vista
    const timer = setTimeout(() => {
      if (shouldShowPrompt()) setVisible(true);
    }, 4000);
    return () => clearTimeout(timer);
  }, [user, shouldShowPrompt]);

  const handleAllow = async () => {
    setLoading(true);
    try {
      await subscribe();
    } finally {
      setVisible(false);
      setLoading(false);
    }
  };

  const handleDismiss = () => {
    dismissPrompt();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 z-50 animate-slide-up md:left-auto md:right-4 md:bottom-6 md:w-80">
      <div className="relative bg-card border border-border rounded-2xl shadow-lg p-4">
        <button
          onClick={handleDismiss}
          aria-label="Cerrar"
          className="absolute top-3 right-3 p-1 rounded-full hover:bg-muted"
        >
          <X className="h-4 w-4 text-muted-foreground" />
        </button>

        <div className="flex items-start gap-3">
          <div className="h-12 w-12 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
            <Bell className="h-6 w-6 text-primary" />
          </div>
          <div className="flex-1 min-w-0 pr-6">
            <h3 className="font-semibold text-sm">Activá las notificaciones</h3>
            <p className="text-xs text-muted-foreground mt-0.5">
              Enterate al instante de pedidos, mensajes y novedades de tus tiendas favoritas.
            </p>
          </div>
        </div>

        <div className="flex gap-2 mt-3">
          <Button
            variant="outline"
            size="sm"
            className="flex-1 h-10 text-xs"
            onClick={handleDismiss}
            disabled={loading}
          >
            Ahora no
          </Button>
          <Button
            size="sm"
            className="flex-1 h-10 text-xs"
            onClick={handleAllow}
            disabled={loading}
          >
            {loading ? "Activando…" : "Activar"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PushNotificationPrompt;
